<!-- Обсуждение пометки по транспортному средству. -->
<template>
  <div class="vehicle-remark-comments">
    <button
      type="button"
      class="vehicle-remark-comments__toggle"
      @click="expanded = !expanded"
    >
      <BaseSectionHeader :title="title" icon="comment" :count="comments.length" />
      <AppIcon
        name="chevronRight"
        :size="16"
        class="vehicle-remark-comments__chevron"
        :class="{ 'vehicle-remark-comments__chevron--expanded': expanded }"
      />
    </button>

    <div v-if="expanded" class="vehicle-remark-comments__body">
      <div v-if="comments.length" class="vehicle-remark-comments__list">
        <VehicleRemarkCommentItem
          v-for="comment in comments"
          :key="comment.id"
          :comment="comment"
          :current-user-id="currentUserId"
          :is-submitting="isSubmitting"
          @destroy="$emit('destroy-comment', comment)"
        />
      </div>

      <slot v-if="!readonly" name="form">
        <VehicleRemarkCommentForm
          :is-submitting="isSubmitting"
          @submit="$emit('submit', $event)"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import VehicleRemarkCommentForm from "@/components/Vehicle/Remark/Comments/Form.vue";
import VehicleRemarkCommentItem from "@/components/Vehicle/Remark/Comments/Item.vue";

export default {
  name: "VehicleRemarkCommentsList",

  components: {
    AppIcon,
    VehicleRemarkCommentForm,
    VehicleRemarkCommentItem,
  },

  props: {
    title: {
      type: String,
      default: "Комментарии",
    },
    comments: {
      type: Array,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    initiallyExpanded: {
      type: Boolean,
      default: false,
    },
    currentUserId: {
      type: [String, Number],
      default: null,
    },
  },

  emits: ["destroy-comment", "submit"],

  data() {
    return {
      expanded: this.initiallyExpanded,
    };
  },
};
</script>

<style scoped>
.vehicle-remark-comments {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--color-grey);
}

.vehicle-remark-comments__toggle {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #475569;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.vehicle-remark-comments__toggle:hover {
  color: var(--color-green-hover);
}

.vehicle-remark-comments__chevron {
  transition: transform 0.2s ease;
}

.vehicle-remark-comments__chevron--expanded {
  transform: rotate(90deg);
}

.vehicle-remark-comments__body,
.vehicle-remark-comments__list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}
</style>
